import * as React from 'react'
// import { useState } from 'react'
import { Link, Script } from 'gatsby'
import Logo from '../assets/logo.svg'
import Footer from './footer'
import ServicesIcon from '../assets/services-icon.svg'
import ReferencesIcon from '../assets/references-icon.svg'
//import UseCasesIcon from '../assets/use-cases-icon.svg'
import AboutUsIcon from '../assets/about-us-icon.svg'
import JobsIcon from '../assets/jobs-icon.svg'
import ProductsIcon from '../assets/products-icon.svg'
import BlogIcon from '../assets/blog-icon.svg'
import ContactIcon from '../assets/contact-icon.svg'
import ChevronIcon from '../assets/chevron-icon.svg'
// import GlobeIcon from '../assets/globe-icon.svg'
// import MoonIcon from '../assets/moon-icon.svg'
import { LayoutProvider } from "./layout-context";
import LayoutConsumer from "./layout-context";
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import CookieConsent from 'react-cookie-consent';
import { useLocation } from "@reach/router" // this helps tracking the location
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'

const Layout = ({ children }) => {
  const [isNavOpen, setIsNavOpen] = React.useReducer((state) => !state, false); // initiate isNavOpen state with false
  const [isNavOpenDesktop, setIsNavOpenDesktop] = React.useState(() => {
    if (typeof localStorage === 'undefined') {
      return true;
    } else {
      return localStorage.getItem('menuOpen') !== 'false';
    }
  });
  
  const windowSize = useWindowSize();
  
  const links = [
    {label: 'Leistungen', url: '/services', icon: (<ServicesIcon className="h-8 w-8" />)},
    {label: 'Referenzen', url: '/references', icon: (<ReferencesIcon className="h-8 w-8" />)},
    /*{label: 'Use Cases', url: '/use-cases', icon: (<UseCasesIcon className="h-8 w-8" />)},*/
    {label: 'Produkte', url: '/products', icon: (<ProductsIcon className="h-8 w-8" />)},
    {label: 'Über Uns', url: '/about-us', icon: (<AboutUsIcon className="h-8 w-8" />)},
    {label: 'Jobs', url: '/jobs', icon: (<JobsIcon className="h-8 w-8" />)},
    {label: 'Blog', url: '/blog', icon: (<BlogIcon className="h-8 w-8" />)},
    {label: 'Kontakt', url: '/contact', icon: (<ContactIcon className="h-8 w-8" />)},
  ]
  
  const handleDesktopNavToggle = () => {
    setIsNavOpenDesktop((prev) => {
      if(prev == null) {
        prev = document.body.classList.contains('desktop-menu-open');
      }
      window.__setMenuOpen(!prev);
      return !prev
    });
  }
  
  const handleNavToggle = () => {
    if(windowSize.width >= 1024) return;
    setIsNavOpen((prev) => !prev);
    window.__setBodyScrollLock(!isNavOpen);
  }

  const location = useLocation();
  
  const [theme, setTheme] = React.useState()
  const handleThemeChange = React.useCallback(event => {
    const { theme } = event;
    setTheme(theme);
  }, []);
  React.useEffect(() => {
    window.addEventListener("handleThemeChange", handleThemeChange);
    return () => {
        window.removeEventListener("handleThemeChange", handleThemeChange);
    };
  }, [handleThemeChange]);
  
  React.useEffect(() => {
    setTheme(document.body.classList.contains('dark') ? 'dark' : 'light');
  }, []);
  
  const ProvenExpertScript = () => {
    useScript(`https://www.provenexpert.com/widget/bar_latori-gmbh.js?style=${theme === 'dark' ? 'black' : 'white'}&amp;feedback=0`);
    return ''
  }
  
  // useScript Hook
  function useScript(src) {
    // Keep track of script status ("idle", "loading", "ready", "error")
    const [status, setStatus] = React.useState(src ? "loading" : "idle");
    React.useEffect(
      () => {
        // Allow falsy src value if waiting on other data needed for
        // constructing the script URL passed to this hook.
        if (!src) {
          setStatus("idle");
          return;
        }
        // Fetch existing script element by src
        // It may have been added by another intance of this hook
        let script = document.querySelector(`script[src="${src}"]`);
        // if (!script) {
          // Create script
          script = document.createElement("script");
          script.src = src;
          script.async = true;
          script.setAttribute("data-status", "loading");
          // Add script to document body
          document.body.appendChild(script);
          // Store status in attribute on script
          // This can be read by other instances of this hook
          const setAttributeFromEvent = (event) => {
            script.setAttribute(
              "data-status",
              event.type === "load" ? "ready" : "error"
            );
          };
          script.addEventListener("load", setAttributeFromEvent);
          script.addEventListener("error", setAttributeFromEvent);
        // } else {
        //   // Grab existing script status from attribute and set to state.
        //   setStatus(script.getAttribute("data-status"));
        // }
        // Script event handler to update status in state
        // Note: Even if the script already exists we still need to add
        // event handlers to update the state for *this* hook instance.
        const setStateFromEvent = (event) => {
          setStatus(event.type === "load" ? "ready" : "error");
        };
        // Add event listeners
        script.addEventListener("load", setStateFromEvent);
        script.addEventListener("error", setStateFromEvent);
        // Remove event listeners on cleanup
        return () => {
          if (script) {
            script.removeEventListener("load", setStateFromEvent);
            script.removeEventListener("error", setStateFromEvent);
          }
        };
      },
      [src] // Only re-run effect if script src changes
    );
    return status;
  }
  

  return (
    <LayoutProvider>
      <LayoutConsumer>
      {({ data }) => (
        <>
          {theme && (<>
              <ProvenExpertScript />
              <div id="ProvenExpert_widgetbar_container"></div>
            </>
          )}
          <nav 
            role="navigation"
            className={`menu transition-width group z-50 fixed shadow-md lg:shadow-none p-4 lg:p-0 lg:pt-16 flex items-center justify-between w-full lg:h-full lg:block dark:text-white bg-gradient-to-b dark:from-[#050505] dark:to-[#171717] lg:bg-gradient-to-r from-[#FFFFFF] to-[#DDDDDD] dark:lg:from-[#050505] dark:lg:to-[#001C0A] lg:overflow-y-scroll no-scrollbar`}
          >
            <Link to="/" className="flex flex-col justify-center items-center w-fit lg:m-auto">
              <Logo className={`logo transition-all h-8`} />
              <span className="uppercase text-sm hidden lg:block">Latori</span>
            </Link>
            <Link to="/" className="text-2xl lg:hidden z-0 relative -left-4">Latori GmbH</Link>
            <div className="menu-container transition-all h-[calc(100%-5rem)] lg:flex justify-between flex-col">
              <div>
                <div aria-expanded={isNavOpen} role="button" className="cursor-pointer flex lg:hidden z-10 top-5 right-4 fixed" onClick={handleNavToggle} onKeyPress={handleNavToggle} tabIndex="0">
                  <div id="mobile-menu-toggle" className={isNavOpen ? 'open' : ''}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div
                  className={`fixed lg:top-16 lg:left-0 w-full md:w-1/2 lg:w-full h-full md:h-fit lg:h-full lg:block lg:static transition-all overflow-hidden overflow-y-scroll lg:overflow-visible lg:bg-transparent dark:lg:bg-transparent pt-12 lg:pt-0 top-0 right-0 before:content-[attr(before)] before:absolute before:w-full before:right-0 before:h-full before:bg-gradient-to-r from-[#FFFFFF] to-[#DDDDDD] dark:from-[#050505] dark:to-[#001C0A] before:transition-all before:duration-200 lg:opacity-100 lg:pointer-events-auto before:lg:static ${isNavOpen ? 'opacity-100 before:top-0 before:right-0 pointer-events-auto h-full' : 'opacity-0 before:!-top-full before:!-right-full pointer-events-none'}`} 
                  before=""
                >
                  <div>
                    <ul className="lg:text-left lg:mt-8 leading-10 flex flex-col gap-4 lg:gap-8 lg:w-fit px-4 lg:px-6 py-4 lg:py-12">
                      {links.map(link => (
                        <li key={link.label} className="relative">
                          <Link 
                            className="text-lg lg:text-xl before:content-[attr(before)] before:absolute before:w-0 before:transition-width before:bg-latori-green-light before:dark:bg-latori-green-dark before:-right-4 lg:before:-left-16 before:z-0 before:rounded-l-3xl lg:before:rounded-l-none lg:before:rounded-r-3xl before:h-[calc(100%+1rem)] before:top-[-0.5rem]"
                            before=" " 
                            activeClassName="before:w-[calc(100%+1rem)] before:lg:w-[calc(100%+5rem)]" 
                            to={link.url} 
                            onClick={() => setTimeout(() => handleNavToggle(), 400)}
                            partiallyActive={true}
                            title={link.label}
                          >
                            <div className="relative flex flex-row items-center gap-4 justify-end lg:justify-start">  
                              {link.icon} 
                              <div className={`menu-label lg:hidden -order-1 lg:order-2`}>{link.label}</div>
                            </div>
                          </Link>
                        </li>
                      ))}
                    </ul>
                    {windowSize.width < 1024 && <MenuOptions isNavOpenDesktop={isNavOpenDesktop} />
                    }
                  </div>
                </div>
              </div>
              {windowSize.width >= 1024 && <MenuOptions isNavOpenDesktop={isNavOpenDesktop} />}
            </div>
            <div className={`menu-chevron transform-gpu fixed top-1/2 left-0 translate-x-[calc(100px-2rem)] -translate-y-1/2 hidden lg:block transition-all`}><ChevronIcon onClick={handleDesktopNavToggle} className={`h-8 w-8 cursor-pointer transition-transform duration-300`} /></div>
          </nav>

          <main className={`main transform-gpu pt-16 lg:pt-0 bg:white dark:bg-background dark:text-white transition-all`}>
            {data.fullWidth
              ? <div>{children}</div>
              : <div className="container px-4 lg:px-8 flex">
                  <div className="mx-auto max-w-screen-lg my-4 lg:my-16">
                    {children}
                  </div>
                </div>
            }
          </main>

          <Footer className={`footer transform-gpu`} />

          <CookieConsent
            overlay="true"
            overlayStyle={{
              "background-color": "rgba(255,255,255,0.75)"
            }}
            style={{
              "display": "block",
              "position": "absolute",
              "top": "50%",
              "left": "50%",
              "transform": "translate(-50%, -50%)",
              "width": "50%",
              "min-width": "300px"
            }}
            buttonStyle={{
              "background": "#ff0071",
              "color": "#fff",
              "padding": "10px 20px"
            }}
            declineButtonStyle={{
              "background": "none",
              "color": "#5ac827"
            }}
            location="none"
            buttonText="Einverstanden"
            declineButtonText="Nein"
            enableDeclineButton="true"
            cookieName="gatsby-gdpr-google-analytics"
            onAccept={(acceptedByScrolling) => {
              initializeAndTrack(location);
            }}
          >
            Wir nutzen Google Analytics um zu verstehen was auf unserer Webseite passiert. Mit Klick auf „Einverstanden“ willigst Du in die Verwendung von Google Analytics ein.
          </CookieConsent>

        </>
        )}
      </LayoutConsumer>
    </LayoutProvider>
  )
}


// useWindowSize Hook
export function useWindowSize() {
  const [windowSize, setWindowSize] = React.useState({
    width: undefined,
    height: undefined,
  });
  
  React.useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener("resize", handleResize, {passive: true});
    handleResize();
    
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  return windowSize;
}

const MenuOptions = ({isNavOpenDesktop}) => {
  const [isDarkTheme, setIsDarkTheme] = React.useState(true);
  const [init, setInit] = React.useState(false);

  React.useEffect(()=>{
    if(!init) return;
    window.__setPreferredTheme(!isDarkTheme ? 'light' : 'dark');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isDarkTheme])

  React.useEffect(()=>{
    setIsDarkTheme(localStorage.getItem('theme') !== "light");
    setInit(true)
  },[])

  return (
    <div className="mt-20 lg:mt-8">
      { /*language switcher */}
      {/* <div className="relative px-4 lg:px-14 pb-4 lg:pb-8 text-right lg:text-left">
        <button onClick={() => toggleLanguageMenu()}><GlobeIcon className="h-6 w-6 lg:h-8 lg:w-8" /></button>
        <div className={`absolute -top-10 lg:-top-full right-16 lg:right-4 left-4 lg:left-1/3 bg-white dark:bg-black transition-opacity ${isNavOpenDesktop && isLanguageMenuToggled ? 'opacity-100' : 'opacity-0'}`}>
          <button onClick={() => toggleLanguageMenu()} className="block w-full text-left p-2 lg:p-4 bg-black/20 dark:bg-white/20 font-bold text-black dark:text-white text-sm lg:text-md underline border-b-2 leading-normal">Deutsch</button>
          <button onClick={() => toggleLanguageMenu()} className="block w-full text-left p-2 lg:p-4 bg-black/10 dark:bg-white/10 font-bold text-black dark:text-white text-sm lg:text-md leading-normal">Englisch</button>
        </div>
      </div> */}
      {/* <label className="relative flex justify-between items-center text-md max-w-fit px-4 pb-8 ml-auto lg:m-0">
        <input defaultChecked={localStorage.getItem('theme') === 'dark' || localStorage.getItem('theme') === null ? true : false} type="checkbox" className="absolute left-1/2 -translate-x-1/2 w-full h-full peer appearance-none rounded-md cursor-pointer" onChange={handleThemeToggle} />
        <span className="w-9 h-4 flex items-center flex-shrink-0 mr-4 p-1 bg-gray-300 rounded-full duration-300 ease-in-out peer-checked:bg-latori-green-light dark:peer-checked:bg-latori-green-dark after:w-5 after:h-5 after:bg-white after:rounded-full after:shadow-md after:duration-300 after:-translate-x-1 peer-checked:after:translate-x-3 cursor-pointer"></span>
        <MoonIcon />
      </label> */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className="transform-gpu pr-4 lg:pr-0 lg:lg:px-6 pb-8 ml-auto lg:m-0 text-lg lg:text-xl flex flex-row items-center gap-4 justify-end lg:justify-start cursor-pointer w-fit" onClick={()=>setIsDarkTheme(!isDarkTheme)}>
        <DarkModeSwitch
          moonColor="black"
          sunColor="white"
          checked={!isDarkTheme}
          onChange={(checked) => {
            setIsDarkTheme(checked);
          }}
          size={32}
          className="w-6 lg:w-8 min-w-6 lg:min-w-8"
        />
        <div className={`lg:hidden -order-1 lg:order-2 z-10${isNavOpenDesktop ? ' lg:!block' : ''}`}>{isDarkTheme ? 'Lightmode' : 'Darkmode'}</div>
      </div>
    </div>
  );
};

export default Layout